// use the amplify API to make a request against quizRestAPI /public/hubspot with the user object

//import { API } from 'aws-amplify';
import Cookies from 'js-cookie';
import { User } from '../types';
import { getUTMParams } from '../utils';
import { getFbcCreationTime } from '../trackingParams';

const getFbclidFromFbc = (fbc: string): string | null => {
  const match = fbc.match(/^fb\.\d+\.\d+\.(.+)$/);
  return match?.[1] || null;
};

const addField = (fields: Record<string, string>, key: string, value: string | null | undefined) => {
  const normalized = value?.trim();
  if (normalized) fields[key] = normalized;
};

const isMetaAttribution = (utm: NonNullable<ReturnType<typeof getUTMParams>>) => {
  const source = utm.utm_source?.toLowerCase() ?? '';
  const medium = utm.utm_medium?.toLowerCase() ?? '';
  const campaign = utm.utm_campaign?.toLowerCase() ?? '';

  return Boolean(
    utm.fbc ||
    source.includes('facebook') ||
    source.includes('meta') ||
    medium.includes('facebook') ||
    medium.includes('meta') ||
    campaign.includes('fbad_')
  );
};

// Read identity + attribution cookies set by App.tsx (Amplitude device ID,
// UTM cookies). Returns only the keys that have values so we don't overwrite
// existing Hubspot contact properties with empty strings on repeat submits.
const getAttributionFields = (): Record<string, string> => {
  const fields: Record<string, string> = {};
  const amplitudeId = Cookies.get('bws_amplitude_device_id');
  if (amplitudeId) {
    fields.amplitudeId = amplitudeId;
    fields.amplitude_device_id = amplitudeId;
  }
  const utm = getUTMParams();
  if (utm) {
    addField(fields, 'utm_source', utm.utm_source);
    addField(fields, 'utm_medium', utm.utm_medium);
    addField(fields, 'utm_campaign', utm.utm_campaign);
    addField(fields, 'utm_term', utm.utm_term);
    addField(fields, 'utm_content', utm.utm_content);
    addField(fields, 'fbp', utm.fbp);
    addField(fields, 'fbc', utm.fbc);

    if (isMetaAttribution(utm)) {
      addField(fields, 'first_meta_utm_source', utm.utm_source);
      addField(fields, 'first_meta_utm_medium', utm.utm_medium);
      addField(fields, 'first_meta_utm_campaign', utm.utm_campaign);
      addField(fields, 'first_meta_utm_term', utm.utm_term);
      addField(fields, 'first_meta_utm_content', utm.utm_content);
      addField(fields, 'first_meta_fbc', utm.fbc);

      if (utm.fbc) {
        addField(fields, 'first_meta_fbclid', getFbclidFromFbc(utm.fbc));
        const capturedAt = getFbcCreationTime(utm.fbc);
        if (capturedAt) {
          fields.first_meta_captured_at = new Date(capturedAt).toISOString();
        }
      }
    }
  }
  return fields;
};
/*
export const submitUserToHubspot = async (user: User, complete: boolean) => {
  return await API.post('quizRestAPI', '/public/hubspot/create-user', {
    body: { ...user, complete }
  });
}

export const saveTimeToGoalToHubspot = async (user: User, timeToGoal: number) => {
  const complete: boolean = true;
  return await API.post('quizRestAPI', '/public/hubspot/save-goal-time', {
    body: { ...user,complete,timeToGoal }
  });
}

*/
export type UserHubspotResponse = {
  userId: string;
};


export const submitUserToHubspot = async (user: User, complete: boolean) => {
  const response = await fetch('https://api.builtwithscience.com/production/gateway/v2/hubspot/create-user', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...user, complete, ...getAttributionFields() })
  });
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  const data: UserHubspotResponse = await response.json();
    return data.userId;
}

export const saveTimeToGoalToHubspot = async (user: User, timeToGoal: number) => {
  const complete = true;
  const response = await fetch('https://api.builtwithscience.com/production/gateway/v2/hubspot/save-goal-time', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...user,
      weight: {
        weightRaw: user.weight,
      },
      goalWeight: {
        goalWeightRaw: user.goalWeight,
      },
      complete,
      timeToGoal,
      ...getAttributionFields(),
    })
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  const data: UserHubspotResponse = await response.json();
  return data.userId;
}

